// extracted by mini-css-extract-plugin
export default {"wrapper":"UserBingoCards-module__wrapper"};